import React, { useState } from "react";
import * as cls from "./assign.module.scss";
import { useDispatch, useSelector } from "react-redux";
import authImg from "../../resources/images/authorization.png";
import { useNavigate } from "react-router-dom";
import { setTokenAction } from "../../redux/actions/actions";
import { useForm } from "react-hook-form";
import { AuthorizationService } from "../authorizationService";
import { Button } from "../../../personal-studio-components/form";

export default function Assign({ setCurrpage, signUpVideoGuide }) {
  const { email, password } = useSelector((state) => state.isValidLogin);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const handleAssign = async (value) => {
    const request = {
      method: "post",
      path: "/student/assign",
      data: {
        ...value,
        email: email,
        password: password,
      },
    };
    const data = await AuthorizationService.send(request, (response) => {});
    if (data.errors) {
      const err = data;
      const errorEvent = new ErrorEvent("error", {
        error: err,
      });
      window.dispatchEvent(errorEvent);
      return;
    }
    dispatch(setTokenAction(data));
    localStorage.setItem(
      "personalStudioAccessToken",
      JSON.stringify(data.access_token)
    );
    localStorage.setItem(
      "personalStudioRefreshToken",
      JSON.stringify(data.refresh_token)
    );
    navigate("/");
  };

  return (
    <div className={cls.root}>
      <div className={cls.imgContainer}>
        <img src={authImg} alt="Authorization" />
      </div>
      <div className={cls.logWrapper}>
        <form
          className={cls.logContainer}
          onSubmit={handleSubmit(handleAssign)}
        >
          <div className={cls.header}>Вход</div>

          <div className={cls.body}>
            <div className={cls.login}>
              <span className={cls.gray_text}>Фамилия</span>
              <input
                autoFocus
                placeholder="Фамилия"
                {...register("surname", { required: true })}
                className={errors.surname ? cls.errorInput : ""}
              />
              <span className={cls.error}>
                {errors.surname && "Это поле обязательно"}
              </span>
            </div>
            <div className={cls.login}>
              <span className={cls.gray_text}>Имя</span>
              <input
                placeholder="Имя"
                {...register("name", { required: true })}
                className={errors.name ? cls.errorInput : ""}
              />
              <span className={cls.error}>
                {errors.name && "Это поле обязательно"}
              </span>
            </div>
            <div className={cls.login}>
              <span className={cls.gray_text}>Отчество</span>
              <input placeholder="Отчество" {...register("secname")} />
            </div>
            <div className={cls.login}>
              <span className={cls.gray_text}>Номер контракта</span>
              <input
                placeholder="Номер контракта"
                {...register("contract_number", { required: true })}
                className={errors.contract_number ? cls.errorInput : ""}
              />
              <span className={cls.error}>
                {errors.contract_number && "Это поле обязательно"}
              </span>
            </div>
          </div>

          {/* <div className={cls.signPrimary}> */}
          {/* <button type="submit">Войти</button> */}
          <Button type="primary">Войти</Button>
          {/* </div> */}
          <div style={{ marginTop: "15px", textAlign: "center" }}>
            <a
              href={signUpVideoGuide}
              target="_blank"
              rel="noopener noreferrer"
            >
              Видеоинструкция по регистрации в Личном кабинете обучающегося
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
